
















import { Component, Vue, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";

@Component({
  components: {
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue")
  }
})
export default class UserActivityLogModal extends Vue {
  @Prop({ required: true })
  public user!: IUser;
}
